export enum HeaderItemLocation {
  start,
  middle,
  end
}
